








































import { defineComponent, ref, watch } from '@vue/composition-api';
import { i18n } from './../../../../i18n';

const DISPLAY_TYPE = {
  recommend: 'recommend',
  search: 'search',
};
const name = 'ttam-psa-preview-middle';
export default defineComponent({
  components: {},
  props: {
    isShowRefreshBtn: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    const showTypeOpts = [
      {
        value: DISPLAY_TYPE.recommend,
        label: i18n.t('psa_preview_display_recommend'),
      },
      {
        value: DISPLAY_TYPE.search,
        label: i18n.t('psa_preview_display_search'),
      },
    ];

    const curDisplayType = ref(DISPLAY_TYPE.recommend);

    watch(
      curDisplayType,
      displayType => {
        emit('change-display-type', displayType);
      },
      {
        immediate: true,
      },
    );

    const handleRefresh = () => {
      emit('refresh');
    };

    return {
      name,
      curDisplayType,
      handleRefresh,
      showTypeOpts,
    };
  },
});
